// extracted by mini-css-extract-plugin
export default {"mobileWidth":"980px","desktopWidth":"1520px","root":"goTop_root__OZ72I","scrollTop":"goTop_scrollTop__8jYeu"};